import { useMutation, useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const ClassroomsQuery = graphql.persisted(
  'ClassroomsQuery',
  graphql(`
    query ClassroomsQuery($schoolId: ID!) {
      school(id: $schoolId) {
        id
        classrooms {
          id
          name
          description
          meetingCount
        }
      }
    }
  `)
);

const CreateClassroomMutation = graphql.persisted(
  'CreateClassroom',
  graphql(`
    mutation CreateClassroom($input: CreateClassroomInput!) {
      createClassroom(input: $input) {
        classroom { id name description meetingCount }
        userErrors { message path }
      }
    }
  `)
);

const UpdateClassroomMutation = graphql.persisted(
  'UpdateClassroom',
  graphql(`
    mutation UpdateClassroom($input: UpdateClassroomInput!) {
      updateClassroom(input: $input) {
        classroom { id name description meetingCount }
        userErrors { message path }
      }
    }
  `)
);

const DeleteClassroomMutation = graphql.persisted(
  'DeleteClassroom',
  graphql(`
    mutation DeleteClassroom($input: DeleteClassroomInput!) {
      deleteClassroom(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export {
  ClassroomsQuery,
  CreateClassroomMutation,
  UpdateClassroomMutation,
  DeleteClassroomMutation,
};

export function useClassroomsQuery(schoolId?: string, skip = false) {
  return useQuery(ClassroomsQuery, {
    variables: { schoolId: schoolId! },
    skip: skip || !schoolId,
  });
}

export function useCreateClassroom() {
  return useMutation(CreateClassroomMutation);
}

export function useUpdateClassroom() {
  return useMutation(UpdateClassroomMutation);
}

export function useDeleteClassroom() {
  return useMutation(DeleteClassroomMutation);
}
